import { NavItem } from '../../nav/primitives/nav-item';
import { useReviewsNavItem } from './use-reviews-nav-item';

export const ReviewsNavItem = () => {
  const item = useReviewsNavItem();
  return <NavItem item={item} />;
};
